<script setup>
import { legalSystemInfo } from '~/assets/jsons/contents/pages/profession/country.json';
import {originalCountries} from '~/assets/jsons/originalParams.json';
import { ref, onMounted } from 'vue';

const route = useRoute();
const { country } = route.params;

const originalCountry = originalCountries[country];
const currentCountry = legalSystemInfo[originalCountry];

// Animasyon için değişkenler
const animatedStats = ref([]);
const animationDuration = 2000; // ms cinsinden animasyon süresi
const statsContainer = ref(null);
const animationStarted = ref(false);

// İstatistikleri başlangıçta ayarla
animatedStats.value = currentCountry.statistics.map(stat => ({
  ...stat,
  currentValue: 0,
  formattedValue: '0'
}));

// Sayıları animasyonla artırma fonksiyonu
function animateNumbers() {
  if (animationStarted.value) return;
  animationStarted.value = true;
  
  const startTime = Date.now();
  
  const updateNumbers = () => {
    const currentTime = Date.now();
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / animationDuration, 1);
    
    animatedStats.value = animatedStats.value.map((stat, index) => {
      const targetValue = currentCountry.statistics[index].numericValue;
      let currentValue = Math.floor(targetValue * progress);
      let formattedValue = '';
      
      // Orijinal değer formatını koruyarak animasyon değerini oluştur
      if (stat.value.includes('%')) {
        formattedValue = currentValue + '%';
      } else if (stat.value.includes('+')) {
        if (currentValue >= 1000) {
          formattedValue = currentValue.toLocaleString() + '+';
        } else {
          formattedValue = currentValue + '+';
        }
      } else {
        formattedValue = currentValue.toString();
      }
      
      return {
        ...stat,
        currentValue,
        formattedValue
      };
    });
    
    if (progress < 1) {
      requestAnimationFrame(updateNumbers);
    }
  };
  
  requestAnimationFrame(updateNumbers);
}

onMounted(() => {
  // Intersection Observer kullanarak görünürlüğü izle
  const observer = new IntersectionObserver((entries) => {
    const [entry] = entries;
    if (entry.isIntersecting && !animationStarted.value) {
      animateNumbers();
    }
  }, {
    threshold: 0.1 // Elemanın %10'u görünür olduğunda tetikle
  });
  
  if (statsContainer.value) {
    observer.observe(statsContainer.value);
  }
});
</script>

<template>
    <section class="py-16 md:py-24 bg-[var(--p-background-ground)]">
      <div class="container mx-auto px-4">
        <h2
        data-aos="fade-up"
        class="text-3xl font-bold text-center mb-12 text-[var(--p-primary-800)]">{{ $t('pages.profession.ourLegalDatabaseCoverage') }}</h2>
        
        <div 
          ref="statsContainer"
          class="flex flex-wrap justify-center gap-8 max-w-4xl mx-auto">
          <div
            v-for="(stat, index) in animatedStats" 
            :key="index" 
            class="bg-[var(--p-background-card)] rounded-lg p-6 text-center shadow-sm hover:shadow-md transition-shadow w-64 flex-shrink-0"
            data-aos="fade-up"
          >
            <i
            :class="`${stat.icon} text-[var(--p-primary-600)] mb-4`" style="font-size: 1.5rem;"></i>
            <h3
            class="text-2xl font-bold text-[var(--p-primary-900)]">{{ stat.formattedValue }}</h3>
            <p
            class="text-[var(--p-text-secondary-color)]">{{ $t(`lawyerCountries.${originalCountry}.statistics.${stat.label}`) }}</p>
          </div>
        </div>
      </div>
    </section>
</template>


<style scoped>

</style>